import fire from '@store/firebase';
import { IpostingItem } from '@typings/posting/posting.interface';
const firestore = fire.firestore();

export async function getDocsbyIDList({
  collectionPath,
  idList,
}: {
  idList: string[];
  collectionPath: string;
}): Promise<IpostingItem[] | any> {
  const ref = firestore.collection(`${collectionPath}`);

  try {
    const results = await Promise.all(
      idList.map(async (id) => {
        const doc = await ref.doc(id).get();
        if (!doc.exists) return null;
        return { id: doc.id, ...doc.data() };
      }),
    );

    // null 값을 필터링하여 존재하는 문서만 반환합니다.
    const filteredResults = results.filter((doc) => doc !== null);

    return filteredResults;
  } catch (error) {
    console.error('Error fetching documents: ', error);
    throw new Error('Error fetching documents');
  }
}
